import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { ApiConnectionModel, ApiConnectionResponseModel } from '../models';
import { API_URL } from '../../../../../services/config';
import { ApiConnectionEndpoint } from '../constants/api-connection-endpoint';

@Injectable({
  providedIn: 'root',
})
export class ApiConnectionItemService {
  constructor(private http: WrapperHttpService) {}

  getApiConnectionDetails(apiConnectionId: string): Observable<ApiConnectionModel> {
    return this.http
      .withLoading()
      .get<ApiConnectionModel>(`${API_URL}${ApiConnectionEndpoint.Base}/${apiConnectionId}`);
  }

  createApiConnection(body: Partial<ApiConnectionModel>): Observable<ApiConnectionResponseModel> {
    return this.http.withLoading().post<ApiConnectionResponseModel>(`${API_URL}${ApiConnectionEndpoint.Base}`, body);
  }

  updateApiConnection(body: Partial<ApiConnectionModel>): Observable<ApiConnectionResponseModel> {
    return this.http.withLoading().post<ApiConnectionResponseModel>(`${API_URL}${ApiConnectionEndpoint.Base}`, body);
  }

  deleteApiConnection(apiConnectionId: number): Observable<void> {
    return this.http.withLoading().delete<void>(`${API_URL}${ApiConnectionEndpoint.Base}/${apiConnectionId}`);
  }
}
